import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import {
  PageHeader,
  SimpleDataTable,
  Section,
  makeBreadcrumb,
  slugify,
  GatsbyLink
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';
import PlanFilter from '../components/PlanFilter';

const SummaryItem = (props) => {
  const { data, location } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent.parent;
  const path = location.pathname;
  const pathPrefix = process.env.GATSBY_PATH_PREFIX;
  const relPath = path.replace(pathPrefix, '');
  const { pageTitle, breadcrumbprops } = makeBreadcrumb({
    href: content.fields.slug,
    text: content.fields.breadcrumbTitle
  });
  const title = `Capital Investment ${content.fields.breadcrumbTitle}`;
  const layoutProps = {
    activeIndex: 1,
    pre: () => <PlanFilter path={relPath} />,
    above: () => <PageHeader title={title} />,
    pageTitle,
    breadcrumbprops,
    buildTimeStamp: site.buildTime,
    dataTimeStamp: modifiedTime,
    containerClasses: 'main-content main-content--two'
  };
  const { data: sumData, ...tableRest } = content.summaryTable;
  const newTableData = sumData.map((row) => {
    const { summaryTableBase, fields } = content;
    // If a display data field exist, use that to render the link text
    const summaryTableDisplay = `${summaryTableBase}Display`;
    const text = row[summaryTableDisplay] || row[summaryTableBase];
    const href = `${fields.slug}${slugify(row[summaryTableBase])}`;
    const replaceKey = row[summaryTableDisplay] ? summaryTableDisplay : summaryTableBase;
    return Object.assign({}, row, {
      [replaceKey]: <GatsbyLink to={href}>{text}</GatsbyLink>
    });
  });
  const tableProps = { data: newTableData, ...tableRest };
  // metadata for the page
  const metaTitle = title;
  const metaDescription = `${title} summary table.`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        metaType: 'dataset',
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <Section>
          {content.summaryTable
          && (
          <React.Fragment>
            <SimpleDataTable title={title} table={tableProps} maxColWidth={375} download={location.pathname} />
          </React.Fragment>
          )
          }
        </Section>
      </Layout>
    </Fragment>
  );
};

SummaryItem.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
};

export default SummaryItem;

export const query = graphql`
  query($slug: String!) {
    site {
      ...SiteMetadata
    }
    content: summaryItem(fields: { slug: { eq: $slug } }) {
      title
      budgetSection
      summaryTableBase
      fields {
        slug
        breadcrumbTitle
      }
      summaryTable {
        title
        headers {
          name
          type
          align
          value
        }
        data {
          govLevelOneDisplay
          govLevelOne
          capitalAgency
          policyArea
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          globalTrustFund
          otherFunds
          total
        }
        total {
          govLevelOneDisplay
          policyArea
          capitalAgency
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          globalTrustFund
          otherFunds
          total
        }
      }
      # Get the last modified timestamp for the file powering the plan item pages
      ...SummaryItemDataTimeStamp
    }
  }
`;
